/**
 * Tiny, dependency-free JWT helpers. Receivers MUST verify the signature
 * via the parent platform's /api/auth/verify-token endpoint before
 * trusting the claims. The decoders in this file are for fast divergence
 * detection (aud, iss, exp) only — they do not verify the signature.
 */
const b64UrlDecode = (s) => {
    // Convert base64url to base64, then decode.
    const padded = s.replace(/-/g, '+').replace(/_/g, '/');
    const pad = padded.length % 4;
    const full = pad ? padded + '='.repeat(4 - pad) : padded;
    if (typeof atob === 'function')
        return atob(full);
    // Node fallback.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return globalThis.Buffer.from(full, 'base64').toString('utf8');
};
const b64UrlDecodeJson = (s) => {
    const json = b64UrlDecode(s);
    return JSON.parse(json);
};
/**
 * Parses a JWT without verifying its signature. Use only to surface
 * aud/iss/exp checks before the server-side verify call.
 */
export function decodeJwt(token) {
    const parts = token.split('.');
    if (parts.length !== 3)
        throw new Error('malformed_jwt');
    return b64UrlDecodeJson(parts[1]);
}
export function isExpired(claims, nowSec = Math.floor(Date.now() / 1000)) {
    const exp = Number(claims.exp);
    return !Number.isFinite(exp) || exp <= nowSec;
}
